import React, { Fragment } from 'react';
import WingingChatIcon from '@/features/editor/ui/WingingChatIcon';
import { useWindowWidth } from '@/shared/lib/hooks/useWindowSize';
import type { AnswerToken } from '@/entities/chat';
import { sanitizeChatHtml } from '@/shared/lib/sanitizeChatHtml';

const DemoChatAnswer = ({
  answer,
  answerRef,
}: {
  answer: AnswerToken[];
  answerRef: any;
}) => {
  const width = useWindowWidth();
  return (
    <div className="answer" ref={answerRef}>
      <div className="main:gap-[38px] flex items-start gap-[18px]">
        <div className={'main:mt-[-14px]'}>
          <WingingChatIcon size={width && width >= 1280 ? 100 : 68} />
        </div>
        <div className="text-label1 main:px-[20px] main:text-body2 main:font-[500] block max-w-[min(734px,90%)] rounded-tl-md rounded-tr-md rounded-br-md border border-gray-100 bg-white px-[10px] py-[10px] text-left font-[400] break-all text-gray-800">
          {answer.map((a, i) => {
            if (
              a.text.trim() === '<br />' ||
              a.text.trim() === '<br/>' ||
              a.text.trim() === '<br>' ||
              a.text.trim() === '\n'
            ) {
              return <br key={i} />;
            }
            if (a.text.trim() === '&nbsp;' || !a.text.trim()) {
              return <Fragment key={i} />;
            }
            return (
              <span
                className="animate-fade-in transition-all"
                key={i}
                dangerouslySetInnerHTML={{
                  __html: sanitizeChatHtml(
                    a.text === '<br /> ' ? '<br />' : a.text
                  ),
                }}
              ></span>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default DemoChatAnswer;
